import { render, staticRenderFns } from "./StoreProductBody.vue?vue&type=template&id=236e5a94&scoped=true"
import script from "./StoreProductBody.vue?vue&type=script&lang=js"
export * from "./StoreProductBody.vue?vue&type=script&lang=js"
import style0 from "./StoreProductBody.vue?vue&type=style&index=0&id=236e5a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e5a94",
  null
  
)

export default component.exports